<template>
  <div class="mb-10">
    <div class="-mb-4 flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>
    <div class="inherit-margin">
      <dropdown-select
        :options="orderedOptions"
        :default="defaultSelection"
        :label="question.description"
        :is-object="true"
        :emit-on-mount="false"
        @input="handleDropdown"
      />
    </div>
  </div>
</template>

<script>
import DropdownSelect from '@/components/DropdownSelect.vue';
import _ from 'lodash';

export default {
  name: 'Select',
  components: {
    DropdownSelect,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      selection: '',
      defaultSelection: '',
    };
  },
  computed: {
    orderedOptions() {
      return _.orderBy(this.question.options, 'order');
      // return orderedOptions.map(el => (el.value))
    },
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.selection = recentAnswer?.answer_options?.[0]?.option_id;
  //     this.defaultSelection = recentAnswer?.answer_options?.[0];
  //     this.handleAutoInput();
  //   } else {
  //     this.defaultSelection = this.question.options.filter(el => (el.id == this.selection))[0]?.option_id;
  //   }
  // },
  watch: {
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.selection = recentAnswer?.answer_options?.[0]?.option_id;
            this.defaultSelection = recentAnswer?.answer_options?.[0];
            this.handleAutoInput();
          } else {
            this.defaultSelection = this.question.options.filter(
              (el) => el.id == this.selection
            )[0]?.option_id;
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {
    const value =
      this.defaultSelection == ''
        ? this.orderedOptions?.[0]?.id
        : this.defaultSelection?.id;

    this.emitForComparison(value);

    const selectedOption = this.orderedOptions?.find((opt) => opt.id === value);
    if (selectedOption) {
      this.handleDropdown(selectedOption);
    }
  },
  methods: {
    handleDropdown(item) {
      this.selection = item.id;
      let body = {
        company_question_id: this.question_id,
        answer_options_attributes: [{ option_id: this.selection }],
      };

      this.setOnboardingPacket(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    handleAutoInput() {
      let body = null;
      if (this.selection) {
        body = {
          company_question_id: this.question_id,
          answer_options_attributes: [{ option_id: this.selection }],
        };
      }

      this.setOnboardingPacket(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
